import { makeStyles } from 'tss-react/mui';
import { colors, spacing } from '../../styles/jss/variables';
import { link } from '../../styles/jss/utils';
const useStyles = makeStyles()((theme) => ({
    searchNewAddressLink: Object.assign(Object.assign(Object.assign({ color: colors.primary.gold5 }, link(colors.primary.gold4)), theme.typography.xxs_regular), { display: 'block', paddingTop: spacing.large, paddingBottom: spacing.xs }),
    floristsContainer: {
        width: '45%',
    },
    collectionModalContainer: {
        display: 'flex',
        overflowY: 'hidden',
    },
    mapContainer: {
        width: '55%',
    },
    collectionModal: {
        '& .MuiDialog-paper': {
            padding: '20px',
            [theme.breakpoints.up('md')]: {
                width: '100%',
                maxWidth: '850px',
                maxHeight: '92vh',
                left: 0,
                padding: 'initial',
            },
            [theme.breakpoints.up('lg')]: {
                maxWidth: '1009px',
            },
            [theme.breakpoints.up('xl')]: {
                maxWidth: '1336px',
            },
        },
    },
    floristGalleryContainer: {
        maxWidth: '796px',
        maxHeight: '400px',
        overflowY: 'scroll',
        padding: `0 ${spacing.large} ${spacing.large}`,
    },
    stickyHeader: {
        position: 'sticky',
        zIndex: 200,
        padding: `${spacing.large} ${spacing.large} 0`,
        boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.08), 0px 2px 8px rgba(0, 0, 0, 0.12)',
    },
    closeButton: {
        position: 'absolute',
        top: spacing.large,
        right: spacing.large,
        border: 'none',
        cursor: 'pointer',
        zIndex: 1000 /* Ensure it stays above the map */,
    },
}));
export default useStyles;
